@if (auth_service.is_logged_in()) {
  @if (_isElemsLoading) {
    <div class="loading-container">
      <ddc-loading-skeleton></ddc-loading-skeleton>
    </div>
  } @else {
    <div class="row home-container">
      <!-- ! Dashboard side -->
      <div class="col dashboard-container">
        <div class="dashboard-card-container">
          <ddc-dashboard-card></ddc-dashboard-card>
          <ddc-explored-cards></ddc-explored-cards>
        </div>
      </div>
      <!-- ! Home Elements side -->
      <div class="col feed-container">
        @if (!_isElemsLoading) {
          <div class="lib-elem-container">
            <div class="elem-content">
              <div>
                <div
                  infiniteScroll
                  [infiniteScrollDistance]="1"
                  [infiniteScrollThrottle]="500"
                  (scrolled)="onElemsScroll()"
                >
                  <div *ngFor="let elem of _elems; let i = index">
                    <ddc-content-card
                      [content]="elem"
                      [dynamicRoute]="
                        '/library/' +
                        (elem.type === 'dictionary' ? 'dic' : elem.type) +
                        '/' +
                        elem.id +
                        '/' +
                        elem.owner.username
                      "
                      (bookmarkChanged)="updateBookmark($event, i)"
                      (clicked)="openReadDialog(i)"
                      (deleteClicked)="openDeleteDialog(i)"
                      (editClicked)="openEditDialog(i)"
                    ></ddc-content-card>
                  </div>
                </div>
                <!-- Info at bottom -->
                <div class="elem-info-label" *ngIf="_nElems > 10">
                  <ng-lottie
                    *ngIf="!_elemsEnd && !_elemsScrollLoading"
                    width="30px"
                    [options]="scroll_options"
                  ></ng-lottie>
                  <ng-lottie *ngIf="_elemsScrollLoading" width="50px" [options]="loading_options"></ng-lottie>
                  <mat-icon *ngIf="_elemsEnd && !_elemsScrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                    _elemsPageInfoLabel
                  }}
                </div>

                <!-- No elems -->
                <ddc-not-available *ngIf="_nElems === 0" [_elem]="'Feed'"></ddc-not-available>
              </div>
            </div>
            <div *ngIf="_isElemsEmpty">{{ _fetchElemsError }}</div>
          </div>
        }
      </div>

      <!-- ! Ads side -->
      <div class="col ads-container">
        <div class="ddc-ads-container">
          <!-- Upgrade card -->
          <ddc-upgrade-card (upgradeClicked)="onUpgradeClicked()"></ddc-upgrade-card>
        </div>
      </div>
    </div>
  }
}
